import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import Header from '../Header';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import { CustomPropType } from '../../utils/propTypes';

const VerticalLayout = (props) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isMobileView, setIsMobileView] = useState(false);

    const location = useLocation();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsSidebarOpen(false);
                setIsMobileView(true);
            } else {
                setIsMobileView(false);
                // Hide sidebar for routes like "/therapist/*"
                if (location.pathname.startsWith("/therapist")) {
                    setIsSidebarOpen(false);
                } else {
                    setIsSidebarOpen(true);
                }
            }
        };

        // Initial check
        handleResize();

        // Event listener for resizing
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, [location]);

    return (
        <div id="layout-wrapper">
            <Header toggleSidebar={toggleSidebar} isMobileView={isMobileView} />
            <div className='d-flex'>
                <Sidebar isOpen={isSidebarOpen} isMobileView={isMobileView} toggleSidebar={toggleSidebar} />
                <main id="main" className={`main ${(isSidebarOpen && !isMobileView) ? 'open' : 'closed'}`}>
                    <div className='main-container' style={{ overflowY: 'auto', background: '#F8F8F8' }}>
                        {props.children}
                    </div>
                </main>
            </div>
            <Footer isOpen={isSidebarOpen} />
        </div>
    );
}

VerticalLayout.propTypes = CustomPropType;

export default VerticalLayout;